import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import type { DisciplineVerzameling } from '@models/DisciplineVerzameling'

import { useAuthenticatedUser } from '../../../../auth/hooks/useAuthenticatedUser'
import { SelectString } from '../../../../core/components/SelectString'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

interface Props {
  project: HoofdleidingProject
  handleClose: () => void
}

export const NetbeheerderDisciplineReferentie = ({
  project,
  handleClose,
}: Props) => {
  const { mutate: saveEvent } = useSaveEvent()
  const { organisatie } = useAuthenticatedUser()
  const [referentie, setReferentie] = useState<string>('')
  const [discipline, setDiscipline] = useState<string | null>(null)

  const [errors, setErrors] = useState<Record<string, boolean>>({})

  const disciplineOptions = project.disciplineVerzamelingen
    .filter((d) => d.netbeheerderLabel === organisatie)
    .map((d) => d.disciplineLabel)

  const handleSubmitClick = () => {
    if (!discipline) {
      setErrors({
        disciplineError: true,
      })
    } else {
      setErrors({
        disciplineError: false,
      })

      saveEvent(
        {
          id: project.aanvraagID,
          data: {
            discipline,
            referentie,
          },
          type: 'hoofdleiding_referentie',
          source: 'manual',
        },
        {
          onSuccess: () => handleClose(),
        },
      )
    }
  }

  const handleDisciplineChange = (value: string | null) => {
    setDiscipline(value)
    const dv = project.disciplineVerzamelingen.find(
      (d) => d.disciplineLabel === value && d.netbeheerderLabel === organisatie,
    ) as DisciplineVerzameling
    setReferentie(dv.referentie || '')
  }

  return (
    <>
      <DialogTitle>Wijzigen netbeheerder discipline referentie</DialogTitle>
      <DialogContent>
        <FormControl sx={{ width: '100%', mt: 2 }}>
          <SelectString
            options={disciplineOptions}
            onChange={handleDisciplineChange}
            value={discipline}
            label="Discipline"
            error={errors.disciplineError}
          />
        </FormControl>
        <FormControl sx={{ width: '100%', mt: 2 }}>
          <TextField
            sx={{ width: '100%' }}
            variant="standard"
            value={referentie}
            label="Referentie"
            onChange={(e) => setReferentie(e.target.value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button color="primary" onClick={handleSubmitClick}>
          Wijzigen
        </Button>
      </DialogActions>
    </>
  )
}
